/**
 * UI-only store for whether the fixed bottom ReferralBanner is currently on
 * screen. The banner (`components/app-shell/ReferralBanner.tsx`) publishes its
 * visibility here so other fixed bottom-anchored elements — today the Shop
 * tab's sticky "Add to Stack" CTA — can reposition around it without
 * prop-drilling through AppLayout. Mirrors the `cartUi` store pattern.
 */

import { useSyncExternalStore } from 'react';

let visible = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export const referralBannerUi = {
  setVisible(next: boolean) {
    if (visible === next) return;
    visible = next;
    emit();
  },
};

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useReferralBannerVisible(): boolean {
  return useSyncExternalStore(subscribe, () => visible);
}
